import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';

import {HttpClient, HttpParams} from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';
import {LolfModel} from '../index';
import {Observable} from 'rxjs';

@Injectable({   providedIn: 'root' })
export class LOLFService extends DaoGeneric<LolfModel> {
  private url = `${environment.baseUrl}/dar/lolfs/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getBase(): Observable<any> {
    return this.httpClient.get<any[]>(`${this.url}getBase/`);
  }

  getByParent(lolf_parent: string): Observable<any> {
    const params = new HttpParams().set('lolf_parent', lolf_parent);

    return this.httpClient.get<any[]>(`${this.url}getByParent/`, { params });
  }
}
